import React from "react";
import config from "../Config";

export default function Upload() {
  const enableSubmit = () => {
    const btn: HTMLInputElement = document.getElementById(
      "submit"
    ) as HTMLInputElement;
    const fileInput: HTMLInputElement = document.getElementById(
      "file"
    ) as HTMLInputElement;
    const soundName: HTMLInputElement = document.getElementById(
      "text"
    ) as HTMLInputElement;
    if (
      fileInput?.files?.item(0)?.name?.toLowerCase().endsWith("mp3") &&
      soundName.value.match(soundName.pattern)?.length &&
      soundName.value.length < 25
    ) {
      btn.disabled = false;
    } else {
      btn.disabled = true;
    }
  };

  const handleChange = (e: any) => {
    const mp3File: File = e.target?.files[0];
    const soundName: HTMLInputElement = document.getElementById(
      "text"
    ) as HTMLInputElement;

    soundName.value = mp3File?.name.split(".")[0] ?? "";

    enableSubmit();
  };

  return (
    <>
      <form
        method="POST"
        action={config.clipCrudUrl}
        encType="multipart/form-data"
        target="submissionIframe"
      >
        <p>
          <label htmlFor="file">MP3 File: </label>
          <input
            type="file"
            id="file"
            name="file"
            data-testid="file"
            accept=".mp3"
            onInput={handleChange}
          />
        </p>
        <p>
          <label htmlFor="sound_name">Sound Name: </label>
          <input
            type="text"
            pattern="[a-z\-]+"
            id="text"
            data-testid="soundName"
            name="sound name"
            onChange={enableSubmit}
          />
        </p>
        <p>
          <small>
            <sup>
              Sound Name must be lowercase and hyphenated{" "}
              <strong>like-this</strong>
            </sup>
          </small>
        </p>
        <p>
          <input type="submit" id="submit" value="Submit" disabled />
        </p>
      </form>

      <small>Upload Response:</small>
      <iframe
        name="submissionIframe"
        id="submissionIframe"
        title="upload-result"
      />
    </>
  );
}
